import { render, staticRenderFns } from "./pogs-form__item--gyne.vue?vue&type=template&id=211f7e10&scoped=true&"
import script from "./pogs-form__item--gyne.vue?vue&type=script&lang=js&"
export * from "./pogs-form__item--gyne.vue?vue&type=script&lang=js&"
import style0 from "./pogs-form__item--gyne.vue?vue&type=style&index=0&id=211f7e10&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "211f7e10",
  null
  
)

export default component.exports